import {
  Action,
  Reducer,
  ThunkAction,
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";
import authReducer from "../redux/authSlice";

const loadState = () => {
  try {
    const loadedState = localStorage.getItem("state");
    if (loadedState === null) return undefined;
    return JSON.parse(loadedState);
  } catch (error: any) {
    return undefined;
  }
};
const persistedState = loadState();

const combinedReducer = combineReducers({
  auth: authReducer,
});

const rootReducer: Reducer = (state: RootState, action: any) => {
  if (action.type === "auth/logOutAction") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const saveState = (state: RootState) => {
  const serializedState: string = JSON.stringify(state);
  localStorage.setItem("state", serializedState);
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
});

store.subscribe(() => {
  saveState(store.getState());
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
